import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	modalDialogLabel: {
		id: 'navigation.global-invite.modal-dialog-label',
		description: 'Accessible label of the modal dialog for assistive technologies users.',
		defaultMessage: 'Invite people',
	},
});
